import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

import Img1 from '../../assets/Starbucks.png';
import Img2 from '../../assets/Costa.png';
import Img3 from '../../assets/CCD.png';
import Img4 from '../../assets/TheCBTL.png';
import Img5 from '../../assets/McCafe.png';
import Img6 from '../../assets/TimHortons.png';
import Img7 from '../../assets/BelgianWaffle.png';
import Img8 from '../../assets/GloriaJean.png';

interface PartnersProps {
  isDark: boolean;
}

const Partners: React.FC<PartnersProps> = ({ isDark }) => {
  const discordFont = {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
  };

  // Array of partner logos with updated names
  const partners = [
    { id: 1, logo: Img1, name: 'Starbucks' },
    { id: 2, logo: Img2, name: 'Costa' },
    { id: 3, logo: Img3, name: 'Café Coffee Day' },
    { id: 4, logo: Img4, name: 'The Coffee Bean & Tea Leaf' },
    { id: 5, logo: Img5, name: 'McCafé' },
    { id: 6, logo: Img6, name: 'Tim Hortons' },
    { id: 7, logo: Img7, name: 'Belgian Waffle' },
    { id: 8, logo: Img8, name: 'Gloria Jean\'s' },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'transparent',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="xl">
        {/* Title Section - Minimal text like FAQ section */}
        <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
          <Typography
            sx={{
              fontSize: { xs: '1rem', md: '1.1rem' },
              mb: 2,
              color: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(5, 24, 20, 0.7)',
              fontWeight: 400,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
            }}
          >
            Our Partners
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              mb: 3,
              color: isDark ? 'white' : '#051814',
              ...discordFont,
            }}
          >
            Trusted by Leading Brands
          </Typography>
        </Box>

        {/* Partner Logos Grid - 3 per row on mobile, 4 per row on desktop */}
        <Grid container spacing={{ xs: 3, md: 6 }} justifyContent="center" alignItems="center">
          {partners.map((partner) => (
            <Grid size={{ xs: 4, sm: 3 }} key={partner.id}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: { xs: '80px', sm: '90px', md: '180px' },
                  width: '100%',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  component="img"
                  src={partner.logo}
                  alt={partner.name}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    padding: { xs: 0.5, sm: 1, md: 2 },
                    filter: isDark 
                      ? 'brightness(1.1) drop-shadow(0 0 10px rgba(196, 182, 111, 0.1))'
                      : 'none',
                    opacity: isDark ? 0.95 : 0.9,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      opacity: 1,
                      filter: isDark 
                        ? 'brightness(1.2) drop-shadow(0 0 15px rgba(196, 182, 111, 0.2))'
                        : 'brightness(1.05)',
                    },
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Partners;